angular.module('ikeweb.notes').controller('NotesListitemController', ['$scope', 'events',
    function($scope, EVENTS) {}
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/notes/notes.listitem.controller.js
// module id = 454
// module chunks = 0